import script from "./BotFeeConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./BotFeeConfig.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__